/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Sort_DescInputs */

const en_table_sort_desc = /** @type {(inputs: Table_Sort_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desc`)
};

const pt_br2_table_sort_desc = /** @type {(inputs: Table_Sort_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrescente`)
};

/**
* | output |
* | --- |
* | "Desc" |
*
* @param {Table_Sort_DescInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_sort_desc = /** @type {((inputs?: Table_Sort_DescInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Sort_DescInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_sort_desc(inputs)
	return pt_br2_table_sort_desc(inputs)
});